import React from 'react';
import packageJson from '../../../package.json';

const Version = () => (
    <div className="version-info">{`Version ${packageJson.version}`}</div>
)

export default Version;